import { createStyles, Loader, useMantineTheme } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  wrapper: {
    backgroundColor: '#000000BB',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 12,
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      borderRadius: 0,
    },
  },
}));

export const ScreenLoader = () => {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const { colors } = theme.other;
  return (
    <div className={classes.wrapper} id="loader">
      <Loader color={colors.primary.default} size="xl" />
    </div>
  );
};

export default ScreenLoader;
